// extracted by mini-css-extract-plugin
module.exports = {"bankmain":"BankOffer_bankmain__20h_r","decor":"BankOffer_decor__2_W8y","bankhead":"BankOffer_bankhead__14lgB"};